import React from 'react';
import { __ } from '@wordpress/i18n';

interface Props {
  searchTerm: string;
  setSearchTerm: (value: string, any) => void;
}

const SearchClearButton = ({ searchTerm, setSearchTerm }: Props) => (
  <button
    aria-hidden={!searchTerm}
    aria-label={__('Clear search', 'wp-plugin-jobs')}
    className={`search-header__clear-button${searchTerm ? ' is-visible' : ''}`}
    disabled={!searchTerm}
    onClick={() => setSearchTerm('', { shouldClearFilters: false })}
  ></button>
);

export default SearchClearButton;
